import React, { useState, useEffect } from "react";
import Auth from "./views/auth";
import Scanner from "./views/scanner";
import ScannedData from "./views/scanned-data/ScannedData";
import UpdateNotification from './views/updatenotification/UpdateNotification';
import { auth } from "./firebase"; // 🔸 Make sure this is the correct path
import { onAuthStateChanged } from "firebase/auth"; // 🔸 Import this

import "./index.css";

function App() {
  const [user, setUser] = useState(null); // Logged-in user
  const [view, setView] = useState("auth"); // Current view
  const [uniqueKey, setUniqueKey] = useState(null); // From Scanner
  const [userID, setUserID] = useState(null); // From Scanner
  const [checkingAuth, setCheckingAuth] = useState(true); // Loading state

  // 🔸 Automatically check for existing login session
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        setView("scannedData");
      }
      setCheckingAuth(false);
    });

    return () => unsubscribe(); // Clean up the listener
  }, []);

  const handleBackToScanner = () => setView("scannedData");

  const handleSignIn = (loggedInUser) => {
    setUser(loggedInUser);
    setView("scannedData");
  };

  // 🔸 Prevent flicker while checking login session
  if (checkingAuth) return <div>Loading...</div>;

  return (
    <div className="App">
      <UpdateNotification />
      <h1>Delivery Tracker</h1>
      {view === "auth" && <Auth onSignIn={handleSignIn} />}
      {view === "scannedData" && (
        <ScannedData user={user} onStartScan={() => setView("scanner")} />
      )}
      {view === "scanner" && (
        <Scanner
          user={user}
          onStopScan={() => setView("scannedData")}
          setUniqueKey={setUniqueKey}
          setUserID={setUserID}
        />
      )}
    </div>
  );
}

export default App;
